const companiesArray = [
  { id: 1, company: 'Apple', symbol: 'AAPL' },
  { id: 2, company: 'Google', symbol: 'GOOG' },
  { id: 3, company: 'NVIDIA', symbol: 'NVDA' },
  { id: 4, company: 'Sony', symbol: 'SONY' },
  { id: 5, company: 'IBM', symbol: 'IBM' },
  { id: 6, company: 'Meta', symbol: 'META' },
];

export default companiesArray;
